import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { PortfolioTabs } from '~/@pages_account-portfolio/PortfolioTabs'
import { AccountFundsButtons } from './portfolio_components/account-funds-buttons/AccountFundsButtons'
import { HeadingOne } from '~/@mid_ui/typography/HeadingOne'
import { Outlet } from 'react-router-dom'

function AccountPage() {
  const isDesktop = useIsDesktop()
  return (
    <>
      <PageContainer className="flex flex-row items-center justify-between pt-15 md:pt-20 pb-5 md:pb-10">
        <HeadingOne>Moje portfólio</HeadingOne>
        {isDesktop && <AccountFundsButtons />}
      </PageContainer>

      <PortfolioTabs content={<Outlet />} />

      {!isDesktop && (
        <PageContainer className="py-5 md:py-8">
          <AccountFundsButtons />
        </PageContainer>
      )}
    </>
  )
}

export default AccountPage
